import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {WinMeterEvents} from '@gongxigames/framework/slot/modules/winmeter';
import {ReelsEvents} from '@gongxigames/framework/slot/modules/reels';
import {SpinButtonEvents} from '@gongxigames/framework/slot/modules/spinbutton';
import {BigWinEvents} from '@gongxigames/framework/slot/modules/bigwin';
import {WinPresentationView} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationView';
import {WinPresentationModule} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationModule';
import {WinPresentationViewEvents} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationViewEvents';
import {WinPresentationEvents} from '@gongxigames/framework/slot/modules/winpresentation/WinPresentationEvents';
import {KeypadControlsEvents} from '@gongxigames/framework/slot/modules/keypadControls/KeypadControlsEvents';

export class WinPresentationInitialState extends ModuleState<WinPresentationView, WinPresentationModule> {

    public onEnterState(): void {
        this.emit(WinMeterEvents.STOP_FINAL_VALUE_TIMER);
        this.module.play(false);
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
        this.setEventHandler(ReelsEvents.REELS_SPINNING_STARTED, this.onSpinButtonPressed.bind(this));
        this.setEventHandler(SpinButtonEvents.SPIN_BUTTON_PRESSED, this.onSpinButtonPressed.bind(this));
        this.setEventHandler(WinPresentationViewEvents.INITIAL_ANIMATION_FINISHED, this.onInitialAnimationFinished.bind(this));
        this.setEventHandler(BigWinEvents.FINISHED, this.onBigWinFinished.bind(this));
        this.setEventHandler(KeypadControlsEvents.TOTAL_BET_CHANGED, this.onBetChanged.bind(this));
    }

    protected onBigWinFinished(): void {
        if (this.module.isIndividualWinMustBePaused) {
            this.module.isIndividualWinMustBePaused = false;
        }
        this.module.gotoState(WinPresentationModule.PAYS_STATE);
    }

    protected onSpinButtonPressed(): void {
        this.module.stop();
        this.module.stopMeter(false);
        this.module.gotoState(WinPresentationModule.BASIC_STATE);
        this.emit(WinPresentationEvents.INITIAL_ANIMATION_FINISHED);
        this.emit(WinPresentationEvents.INITIAL_ANIMATION_SKIPPED);
    }

    protected onInitialAnimationFinished(): void {
        this.emit(WinPresentationEvents.INITIAL_ANIMATION_FINISHED);

        if (this.module.isIndividualWinMustBePaused) {
            this.module.stop();

            if (this.module.logic.nextAction === Action.PICK || this.module.logic.nextAction === Action.SELECT) {
                this.module.stopMeter(true);
            }

            this.module.isIndividualWinMustBePaused = false;
        } else {
            this.module.gotoState(WinPresentationModule.PAYS_STATE);
        }
    }

    protected onBetChanged(): void {
        this.emit(WinPresentationEvents.INITIAL_ANIMATION_SKIPPED);
    }
}
